export default __webpack_public_path__ + "static/media/mt5-laptop.f1888e9f.png";